import React from 'react';
import { Box } from '@mui/material';

import {
  Typography,
  Button,
  ConfirmDialog,
  StatusChip,
  FormInputWithButtonRow,
  CircularProgress,
  ChipBox,
  ChipType,
} from '@occc-app/design-system';

import { Card, CardHeader, CardContent } from './Card';

//TODO need attention

export type AdditionalButtonProps = {
  value: string;
  handleAddValue: () => void;
};

export type Props = {
  addedValues: string[];
  addedValuesCopy: string;
  helpText?: string;
  loading?: boolean;
  onAdd: (value: string) => any;
  onRemoveAllValues: () => void;
  onValueRemoved: (value: string) => void;
  readonly: boolean;
  removeAllAddedValuesCopy: string;
  valueType: string;
  isError?: boolean;
  onBlur?: () => void;
  onInputChange?: () => void;
  required?: boolean;
  parse?: (value: string) => any;
  additionalButton?: React.ComponentType<AdditionalButtonProps>;
};

type InstanceState = {
  showConfirmRemoveAllValuesModal: boolean;
};

export class ValueBadgeInput extends React.Component<Props, InstanceState> {
  state: InstanceState = {
    showConfirmRemoveAllValuesModal: false,
  };

  onChipDelete = (chipToDelete: string) => {
    const { onValueRemoved, readonly } = this.props;

    if (!readonly) {
      onValueRemoved(chipToDelete);
    }
  };

  renderAddedValues() {
    const { addedValues, addedValuesCopy } = this.props;

    const badgeItems: ChipType[] = addedValues.map((value) => ({ id: value, name: value }));

    const cardTitle = (
      <Box display='flex' alignItems='center'>
        <Typography component='div' variant='subtitle1'>
          Total
        </Typography>
        <Box ml={1}>
          <StatusChip variant='success' label={badgeItems.length} />
        </Box>
      </Box>
    );

    return (
      <Box mt={3}>
        <Typography paragraph variant='subtitle1'>
          {addedValuesCopy}
        </Typography>
        <Card>
          <CardHeader title={cardTitle} action={this.renderRemoveAllValuesButton()} />
          <CardContent>
            <ChipBox items={badgeItems} onDelete={this.onChipDelete} />
          </CardContent>
        </Card>
      </Box>
    );
  }

  renderRemoveAllValuesButton() {
    if (this.props.readonly) {
      return;
    }

    const removeAllValues = () => {
      this.setState({ showConfirmRemoveAllValuesModal: true });
    };

    return (
      <Button variant='contained' size='small' color='secondary' onClick={removeAllValues}>
        clear all
      </Button>
    );
  }

  renderRemoveAllValuesModal() {
    const { onRemoveAllValues, removeAllAddedValuesCopy } = this.props;

    const { showConfirmRemoveAllValuesModal } = this.state;

    const removeAllValuesConfirmed = () => {
      onRemoveAllValues();
      this.setState({ showConfirmRemoveAllValuesModal: false });
    };
    const removeAllValuesCancelled = () =>
      this.setState({ showConfirmRemoveAllValuesModal: false });

    return (
      <ConfirmDialog
        dialogTitle={removeAllAddedValuesCopy}
        open={showConfirmRemoveAllValuesModal}
        confirmButtonText='Confirm'
        confirmButtonProps={{
          onClick: removeAllValuesConfirmed,
          color: 'error',
        }}
        onClose={removeAllValuesCancelled}
      >
        <Typography> Are you sure?</Typography>
      </ConfirmDialog>
    );
  }

  renderValuesInput() {
    const {
      helpText,
      onBlur,
      onInputChange,
      isError,
      required,
      onAdd,
      valueType,
      readonly,
      parse,
      additionalButton,
    } = this.props;

    if (readonly) {
      return;
    }

    return (
      <FormInputWithButtonRow
        helpText={helpText}
        label={`Add ${valueType}`}
        onAdd={onAdd}
        isError={isError}
        onBlur={onBlur}
        onInputChange={onInputChange}
        required={required}
        parse={parse}
        additionalButton={additionalButton}
      />
    );
  }

  render() {
    const { addedValues, loading } = this.props;
    const { showConfirmRemoveAllValuesModal } = this.state;

    if (loading !== undefined && loading) {
      return <CircularProgress size={24} />;
    }

    return (
      <>
        {this.renderValuesInput()}
        {addedValues && addedValues.length > 0 && this.renderAddedValues()}
        {showConfirmRemoveAllValuesModal && this.renderRemoveAllValuesModal()}
      </>
    );
  }
}
